import { AsyncComponent } from '@frontend/elements';
import { ProductType } from '@frontend/product/types';
import { lazy } from 'react';
import { Route } from 'react-router-dom';

import { ProductAttributesRoutes } from '../product-attribute/product-attribute-routes';
import ProductCreateRedirect from '../product/product-create/product-create-redirect.component';
import { EquipmentRoutes } from './equipment/equipment-routes';

const EquipmentProductOverview = lazy(() => import('./equipment-product-overview/equipment-product-overview.component'));
const EquipmentProductDetail = lazy(() => import('./equipment-product-detail/equipment-product-detail.component'));
const EquipmentProductUpdate = lazy(() => import('./equipment-product-update/equipment-product-update.component'));
const EquipmentCreate = lazy(() => import('./equipment/equipment-create/equipment-create.component'));
const AddCertificate = lazy(() => import('../product/product-detail/add-certificate/add-certificate.component'));

export function EquipmentProductRoutes() {
    const ProductAttributeRoute = ProductAttributesRoutes();
    const EquipmentRoute = EquipmentRoutes();
    return (
        <Route path='equipment-products'>
            <Route
                index
                element={
                    <AsyncComponent>
                        <EquipmentProductOverview />
                    </AsyncComponent>
                }
            />
            <Route
                path='create'
                element={<ProductCreateRedirect type={ProductType.EQUIPMENT} />}
            />
            <Route
                path='equipment/create'
                element={
                    <AsyncComponent>
                        <EquipmentCreate />
                    </AsyncComponent>
                }
            />
            <Route path=':productId'>
                <Route
                    path='detail'
                    element={
                        <AsyncComponent>
                            <EquipmentProductDetail />
                        </AsyncComponent>
                    }
                />
                <Route
                    path='update'
                    element={
                        <AsyncComponent>
                            <EquipmentProductUpdate />
                        </AsyncComponent>
                    }
                />
                <Route
                    path='add-certificate'
                    element={
                        <AsyncComponent>
                            <AddCertificate />
                        </AsyncComponent>
                    }
                />
                {EquipmentRoute}
                {ProductAttributeRoute}
            </Route>
        </Route>
    );
}
